import { render, staticRenderFns } from "./PDLMessages.vue?vue&type=template&id=36008aaa&scoped=true&"
import script from "./PDLMessages.vue?vue&type=script&lang=js&"
export * from "./PDLMessages.vue?vue&type=script&lang=js&"
import style0 from "./PDLMessages.vue?vue&type=style&index=0&id=36008aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36008aaa",
  null
  
)

export default component.exports